import { fragments as artOrderStatusFragments } from "../../application/apps/ArtApp/components/ArtOrderStatus/graph";
import { gql } from "@apollo/client";

const markOrderAsArtworkReviewedMutation = gql`
  mutation ($orderId: ID!) {
    markOrderAsArtworkReviewed(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...ArtOrderStatus_order
      }
      succeeded
    }
  }
  ${artOrderStatusFragments.order}
`;

export default markOrderAsArtworkReviewedMutation;
